module.exports = __webpack_public_path__ + "img/learnModel-ball-lg-desktop.36a573c5.png";